import { MediaQueries } from 'custom_hooks/useWindowSize';
import styled, { keyframes } from 'styled-components';
import { ComponentContainer } from 'styles/theme_styles/ComponentContainer';
import { KCFColor } from 'styles/themes/KCFColor';

export const MetricContainer = styled(ComponentContainer)`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 2rem 4.8rem;
    gap: 2rem;
    background: ${KCFColor.blueGrey};
    border-radius: 0.8rem;
    flex-basis: unset;

    @media (min-width: 1024px) {
        display: flex;
        flex-direction: row;
        padding: 1.6rem 9.6rem;
        justify-content: space-around;
        align-items: center;
        gap: 0;
    }
`;

export const MetricCard = styled.div`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    width: 100%;
    min-width: 0;
    margin: 0;

    @media (min-width: 1024px) {
        width: auto;
    }
`;

export const MetricIconWrapper = styled.div`
    display: flex;
    min-width: 3.2rem;
    width: 3.2rem;
    height: 3.2rem;
    justify-content: center;
    align-items: center;
    border-radius: 999.9rem;
    background: ${KCFColor.mediumGrey5};
    color: ${KCFColor.white};
    flex-shrink: 0;
`;

export const MetricContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 0.8rem;
    min-width: 0;
    flex: 1;
    overflow: hidden;
`;

export const MetricValue = styled.div`
    color: ${KCFColor.white};
    font-size: 2.8rem;
    font-style: normal;
    font-weight: 500;
    line-height: 3.2rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media ${MediaQueries.mediumAndUp} {
        font-size: 3.5rem;
        line-height: 4rem;
    }
`;

export const MetricLabel = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: ${KCFColor.lightGrey2};
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.6rem;
    text-transform: uppercase;
    margin-top: 0.4rem;
    overflow: hidden;
`;

export const MetricSubLabel = styled.span`
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.6rem;
    color: ${KCFColor.lightGrey2};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

// Loading Components
export const shimmer = keyframes`
    0% {
        background-position: -20rem 0;
    }
    100% {
        background-position: 20rem 0;
    }
`;

export const MetricSkeletonBase = styled.div`
    background: linear-gradient(
        90deg,
        ${KCFColor.blueGrey} 25%,
        ${KCFColor.mediumGrey5} 37%,
        ${KCFColor.blueGrey} 63%
    );
    background-size: 40rem 100%;
    animation: ${shimmer} 1.2s ease-in-out infinite;
    border-radius: 0.4rem;
`;

export const MetricSkeletonCircle = styled(MetricSkeletonBase)`
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 999.9rem;
    background: ${KCFColor.mediumGrey5};
`;

export const MetricSkeletonValue = styled(MetricSkeletonBase)`
    width: 8rem;
    height: 3.2rem;
    margin-right: 0.8rem;

    @media ${MediaQueries.mediumAndUp} {
        height: 4rem;
        width: 10rem;
    }
`;

export const MetricSkeletonLabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
`;

export const MetricSkeletonLabel = styled(MetricSkeletonBase)`
    width: 6rem;
    height: 1.2rem;
`;

export const MetricSkeletonSubLabel = styled(MetricSkeletonBase)`
    width: 4rem;
    height: 1.2rem;
`;
